import {getTracerModules} from '@apptracer/sdk';

let _isRecoveringFromError = false;

type RecoverableErrorType = 'chunk' | 'conn';

const getErrorType = (error: Error): RecoverableErrorType | null => {
  if (
    error.name === 'ChunkLoadError' ||
    error.message?.startsWith('Loading CSS chunk')
  ) {
    getTracerModules().log?.log(
      'Chunk load error: ' + error.name + ' ' + error.message,
    );
    return 'chunk';
  }
  if (error.message?.includes('Connection closed')) {
    getTracerModules().log?.log(
      'Connection closed error: ' + error.name + ' ' + error.message,
    );
    return 'conn';
  }

  return null;
};

export const tryRecoverFromError = (error: Error) => {
  if (_isRecoveringFromError) {
    console.warn('Pending reload to recover, skipping error', error);
    return true;
  }
  const errorType = getErrorType(error);
  if (!errorType) {
    return false;
  }

  // форсим перезагрузку страницы, вдруг чанки подтянутся
  const key = 'rcvr';
  const searchParams = new URLSearchParams(window.location.search);
  const existingQueryParam = searchParams.get(key);
  if (existingQueryParam?.includes(errorType)) {
    // уже с такой же кверей - значит не помогло, увы :)
    return false;
  }

  getTracerModules().log?.log('Will try to recover from error');
  searchParams.set(key, `${Date.now()}_${errorType}`);
  _isRecoveringFromError = true;

  setTimeout(() => {
    window.location.search = searchParams.toString();
  }, 1000);

  return true;
};
